import { asDate, asNumber, asRaw, asString } from './guards'

/** Port of constructors/external_platform.js */
export class ExternalPlatform {
  id: number | null
  name: string | null
  logo_media_id: number | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.name = asString(d.name)
    this.logo_media_id = asNumber(d.logo_media_id)
  }
}

/**
 * A platform and whether the signed-in user has linked it, from
 * GET /me/external_platforms. Tokens stay server-side.
 */
export class PlatformConnection {
  id: number | null
  name: string | null
  logo_media_id: number | null
  auth_url: string | null
  connected: boolean
  connected_at: Date | null
  expires_at: Date | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.name = asString(d.name)
    this.logo_media_id = asNumber(d.logo_media_id)
    this.auth_url = asString(d.auth_url)
    this.connected = d.connected === true
    this.connected_at = asDate(d.connected_at)
    this.expires_at = asDate(d.expires_at)
  }
}

export function platformConnectionListFrom(rows: unknown): PlatformConnection[] {
  return Array.isArray(rows) ? rows.map((row) => new PlatformConnection(row)) : []
}
